<script setup>
import { computed } from 'vue';

const props = defineProps({
  rating: { type: Number, default: 0 },
  size: {
    type: String,
    default: 'sm',
    validator: value => ['xs', 'sm', 'md'].includes(value),
  },
  showValue: { type: Boolean, default: false },
});

const stars = computed(() =>
  [1, 2, 3, 4, 5].map(position => {
    if (props.rating >= position) return 'i-ri-star-fill';
    if (props.rating >= position - 0.5) return 'i-ri-star-half-fill';
    return 'i-ri-star-line';
  })
);

const sizeClass = computed(
  () => ({ xs: 'size-3', sm: 'size-3.5', md: 'size-[18px]' })[props.size]
);

const toneClass = computed(() => {
  if (props.rating >= 4) return 'text-n-amber-9';
  if (props.rating >= 3) return 'text-n-amber-8';
  return 'text-n-ruby-9';
});
</script>

<template>
  <span class="inline-flex items-center gap-1">
    <span class="inline-flex items-center" :class="toneClass">
      <span
        v-for="(star, index) in stars"
        :key="index"
        :class="[star, sizeClass]"
      />
    </span>
    <span
      v-if="showValue"
      class="text-xs font-semibold tabular-nums text-n-slate-12"
    >
      {{ rating.toLocaleString(undefined, { maximumFractionDigits: 1 }) }}
    </span>
  </span>
</template>
